module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOCAYAAAASVl2WAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAAwSURBVBiVY/j///99KFZgwAagkv9xKvr//7/CYFfEhNVruABeK2gkCVVA0Ft4IwsAk6/RkP7BovMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/1IconColor.png
// module id = +whT
// module chunks = 1